<template>
  <v-container grid-list-xs>
    <v-row class="text-h3">
      Configure NoahFace Screen Details
    </v-row>
    <v-container class="inputs">
      <v-row class="text-h5">
        Task Tracking
      </v-row>
      <v-divider />
      <v-row class="text-h6 mt-3">
        Options
      </v-row>
      <v-text-field
        v-model="taskLabel"
        label="Task Label"
        hint="What are the things you're picking from called?"
      />
      <v-text-field
        v-model="outLabel"
        label="Out Label"
        hint="What should the 'Clock Out' button say?"
        :disabled="hideout"
      />
      <v-checkbox v-model="hideout" :label="`Hide the '${outLabel}' button`" />
      <v-checkbox
        v-model="specifyValues"
        :label="`Give ${taskLabel.toLowerCase()}s separate names and values`"
      />

      <v-divider />

      <v-row class="text-h6 mt-3">
        {{ taskLabel }} List
      </v-row>
      <v-row v-for="(task, i) in tasks" :key="i" align="baseline">
        {{ +i + 1 }}.
        <v-col>
          <v-text-field
            v-model="task.name"
            label="Name"
          />
        </v-col>
        <v-col v-if="specifyValues" sm="5">
          <v-text-field
            v-model="task.value"
            label="Value"
          />
        </v-col>
        <v-col sm="1">
          <v-btn icon color="error" @click="deleteTask(i)">
            <v-icon>
              mdi-delete
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-btn icon @click="addTask">
          <v-icon>
            mdi-plus
          </v-icon>
        </v-btn>
      </v-row>
      <v-dialog
        v-model="showCopyDialog"
        max-width="600px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            v-bind="attrs"
            v-on="on"
          >
            Copy from Spreadsheet
          </v-btn>
        </template>
        <v-card>
          <v-card-title class="headline">
            Paste your list of tasks below
          </v-card-title>
          <v-card-text>
            <v-textarea
              v-model="pastedTaskList"
            />
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              text
              @click="showCopyDialog = false"
            >
              Save tasks
            </v-btn>
            <v-btn
              text
              @click="showCopyDialog = false"
            >
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <v-divider />

    <v-container class="output">
      <v-row class="text-h5 mb-3">
        Copy the screen details below:
      </v-row>
      <v-card outlined>
          <v-card-text>
          <v-btn icon color="primary" @click="copyScreenDetails">
            <v-icon>mdi-content-copy</v-icon>
          </v-btn>
            {{ screenDetails }}
          </v-card-text>
      </v-card>
    </v-container>

    <v-snackbar
      v-model="copiedSnackbar"
      timeout=1000
    >
      Copied to clipboard
      <template v-slot:action="{ attrs }">
        <v-btn icon color="blue" @click="copiedSnackbar = false" v-bind="attrs">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

  </v-container>
</template>

<script>
export default {
  data() {
    return {
      taskLabel: 'Task',
      outLabel: 'End Shift',
      hideout: false,
      specifyValues: false,
      tasks: [{ name: 'Demo Task', value: 'task1' }],
      showCopyDialog: false,
      pastedTaskList: '',
      copiedSnackbar: false,
    };
  },
  computed: {
    taskString() {
      return this.tasks.reduce((acc, task) => {
        // eslint-disable-next-line no-param-reassign
        if (acc.length > 0) { acc += ';'; }
        let taskStr = task.name;
        if (this.specifyValues) {
          taskStr += `:${task.value}`;
        }
        return acc + taskStr;
      }, '');
    },

    screenDetails() {
      return `name=${this.taskLabel},out=${this.outLabel},hideout=${this.hideout},tasks=${this.taskString}`;
    },
  },
  methods: {
    addTask() {
      this.tasks.push({ name: '', value: '' });
    },
    deleteTask(i) {
      this.tasks.splice(i, 1);
    },
    copyScreenDetails() {
      window.navigator.clipboard.writeText(this.screenDetails);
      this.copiedSnackbar = true;
    },
  },
};
</script>

<style>
  .inputs {
    margin: 20px;
    padding: 10px;
  }
</style>
